import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import React, { useCallback, useEffect, useState } from 'react';
import { editUserByAdmin } from '../../api/api-middleware';

export default function ToggleUserStatus({ user, fetchData, token, setMessage, setSnackbarOpen }) {
  const [error, setError] = useState(null);
  const [confirmationOpen, setConfirmationOpen] = useState(false);
  const [userData, setUserData] = useState({});
  const [isUserActive, setIsActive] = useState(null);
  useEffect(() => {
    setUserData({ ...user });
    setIsActive(user.status === 'active' ? true : false);
  }, [user]);

  const handleSubmit = useCallback(async () => {
    try {
      const updatedStatus = isUserActive ? 'inactive' : 'active';
      const updatedUser = { status: updatedStatus };
      await editUserByAdmin(userData.id, updatedUser, token);
      fetchData();
      setMessage(`User  ${isUserActive ? 'disabled' : 'enabled'} successfully`);
      setSnackbarOpen(true)
    } catch (error) {
      setError(`Failed to ${isUserActive ? 'disable' : 'enable'} the user`);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchData, isUserActive]);

  const handleButtonClick = () => {
    setConfirmationOpen(true);
  };

  const handleConfirm = () => {
    handleSubmit();
    setConfirmationOpen(false);
  };

  const handleCancel = () => {
    setConfirmationOpen(false);
  };

  return (
    <>
      {isUserActive ? (
        <Button
          variant="text"
          sx={{ cursor: 'pointer', textTransform: 'none', fontSize: 'inherit' }}
          onClick={handleButtonClick}>
          Disable User
        </Button>
      ) : (
        <Button
          variant="text"
          sx={{ cursor: 'pointer', textTransform: 'none', fontSize: 'inherit' }}
          onClick={handleButtonClick}>
          Enable User
        </Button>
      )}
      <Dialog
        open={confirmationOpen}
        onClose={handleCancel}
        fullWidth
        maxWidth="sm">
        <DialogTitle>Confirmation</DialogTitle>
        <DialogContent>
          {error && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {error}
            </Alert>
          )}
          <Typography>
            Are you sure you want to {isUserActive ? 'disable' : 'enable'}{' '}
            <strong>
              {user.first_name} {user.last_name}
            </strong>
            ?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancel} color="primary">
            Cancel
          </Button>
          <Button onClick={handleConfirm} color="secondary">
            {isUserActive ? 'Disable' : 'Enable'}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
